import { handleActions } from 'redux-actions'
import * as type from './type'

export const initialState = {
    anamnesisList: [],
    fetching: false,
    error: null,
    showAnamnesis: false,
    isInfoLegendShown: false,
}

export default handleActions(
    {
        [type.FIND_BY_CUSTOMER_ID_REQUEST]: (state, action) => {
            return {
                ...state,
                error: null,
                fetching: true,
            }
        },
        [type.FIND_BY_CUSTOMER_ID_SUCCESS]: (state, action) => {
            const { anamnesisList } = action.payload
            return {
                ...state,
                fetching: false,
                anamnesisList,
            }
        },
        [type.FIND_BY_CUSTOMER_ID_ERROR]: (state, action) => {
            const { error } = action.payload
            return {
                ...state,
                fetching: false,
                error,
            }
        },
        [type.TOGGLE_ANAMNESIS]: (state, action) => {
            return {
                ...state,
                showAnamnesis: !state.showAnamnesis,
            }
        },
        [type.TOGGLE_INFO_LEGEND]: (state, action) => {
            return {
                ...state,
                isInfoLegendShown: !state.isInfoLegendShown,
            }
        },
    },
    initialState
)



// WEBPACK FOOTER //
// ./src/modules/anamnesis/state/list/reducer.js